export default __webpack_public_path__ + "4ecd0bec01fcb19bc68f9467f88ecbe5.png";